module.exports = __webpack_public_path__ + "static/img/07.5066426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour2/07.jpg
// module id = cax4
// module chunks = 0